import { useMemo, useState } from 'react'
import { getPeriodoMesAtual } from '../../../../../services/util/date.service'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../services/util/error.service'
import { openReportInNewTab } from '../../../../../services/util/report.service'
import {
  gerarArquivoExcel,
  gerarArquivoExcelComColunasBloqueadas,
} from '../../../../../services/util/excel.service'
import _ from 'lodash'
import { menuItemsAllowed } from '../../../../../services/permission/menus'

export const MENU_ITEMS = ['1. Editar']

export const IMPORT_OPTIONS = {
  MODELO: 'MODELO',
  EDICOES: 'EDICOES',
}

const HEADER_EDICAO_POSICOES = ['codigo', 'endereco', 'sequencia', 'capacidade']

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_POSICOES: 'Carregando posições',
  CREATE_POSICOES: 'Criando posições',
  UPDATE: 'Atualizando posições',
  UPDATE_SUCCESS: 'Posições atualizadas com sucesso',
  DELETE: 'Excluindo posição',
  DELETE_MULTIPLES: 'Excluindo posições',
  DELETE_SUCCESS: 'Posição excluida com sucesso',
  SUCCESS: 'Posição criada com sucesso',
  CREATE_POSICOES_SUCCESS_EXCEL: 'Posições importadas com sucesso',
  UPDATE_POSICOES_SUCCESS_EXCEL: 'Posições editadas com sucesso',
  UPDATE_POSICOES_EXCEL: 'Importando edições de posições',
}

const MODAL_INIT_INFO = {
  name: '',
}

const normalizarTextoHeader = value =>
  String(value === null || value === undefined ? '' : value)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

const isNumeroInteiroPositivo = value => /^[1-9]\d*$/.test(String(value).trim())

const isLinhaVazia = row =>
  !row ||
  !row.some(celula => celula !== null && celula !== undefined && String(celula).trim() !== '')

const isValidCapacity = value => {
  const normalizedValue = String(value).trim()
  const numericValue = Number(normalizedValue)

  return (
    /^[1-9]\d{0,5}$/.test(normalizedValue) &&
    Number.isInteger(numericValue) &&
    numericValue > 0 &&
    numericValue <= 999999
  )
}

const INITIAL_STATE = {
  posicoes: [],
  qtePosicoes: 0,
  qtePosicoesOcupadas: 0,
  taxaOcupacao: 0,
  filtroEndereco: '',
  selecionarTodos: false,
  originalPosicoes: [],
  posicoesToUpdate: [],
  modal: {
    show: false,
    data: null,
  },
  periodo: getPeriodoMesAtual(),
  selectedPosicao: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  successMessage: null,
  modalConfirmDelete: {
    show: false,
    data: null,
  },
}

export default function useCadastroPosicoesEstoque() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      onFiltroChange(name, value) {
        setState(prev => ({ ...prev, [name]: value }))
      },

      onBuscarFiltrado() {
        setState(prev => {
          const filtro = (prev.filtroEndereco || '').toLowerCase()
          const base =
            prev.originalPosicoes && prev.originalPosicoes.length
              ? prev.originalPosicoes
              : prev.posicoes
          const filtradas = filtro
            ? base.filter(p => (p.endereco || '').toLowerCase().includes(filtro))
            : base

          filtradas.forEach(p => (p.selected = false))

          return {
            ...prev,
            posicoes: filtradas,
            selecionarTodos: false,
          }
        })
      },
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          successMessage: null,
          errorMessage: null,
        }))
      },

      toggleModal(show, data, tp_id) {
        if (tp_id !== 0)
          setState(prevState => ({ ...prevState, modal: { show: true, data: { ...data } } }))
        else
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico desejado',
          }))
      },

      getLastSequence(posicoes) {
        return Math.max(...posicoes.map(p => p.sequencia))
      },

      excluirPosicao(posicaoId, tpId) {
        EstoqueHttp.deletePosicaoEstoque(tpId, posicaoId)
          .then(() => {
            setState(prevState => {
              prevState.posicoes = prevState.posicoes.filter(p => p.id !== posicaoId)
              prevState.successMessage = 'Posição deletada com sucesso'
              return { ...prevState }
            })
          })
          .catch(err => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            }))
          })
      },

      updatePosicoesEstoque(selectedTp, posicoesToUpdate) {
        EstoqueHttp.updatePosicoesEstoque(selectedTp, posicoesToUpdate)
          .then(() =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.GET_POSICOES,
              successMessage: 'Posições atualizadas com sucesso',
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getPosicoesEstoque(selectedTp, estoqueId) {
        EstoqueHttp.getPosicoesEstoques(selectedTp, estoqueId)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              posicoes: res.map(res => ({ selected: false, ...res })),
              originalPosicoes: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err => {
            setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) }))
          })
      },

      deleteMultiplesPosicoes(selectedTp, selectedPosicoes) {
        EstoqueHttp.deletePosicoesEstoque(
          selectedTp,
          selectedPosicoes.map(s => s.id),
        )
          .then(res => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.GET_POSICOES,
              selecionarTodos: false,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onMenuItemClicked(item, posicao, selectedTp) {
        switch (item) {
          case '1. Editar':
            this.toggleModal(true, posicao, selectedTp)
            break
          case '2. Apagar':
            setState(prevState => ({
              ...prevState,
              selectedPosicao: posicao,
              modalConfirmDelete: { show: true, data: { ...posicao } },
            }))
            break
          default:
            break
        }
      },

      //Events
      onInit(selectedTp) {
        if (selectedTp) {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_POSICOES }))
        }
      },

      onBtnNovo(selectedTp) {
        this.toggleModal(true, { ...MODAL_INIT_INFO }, selectedTp)
      },

      onModalClose() {
        setState(prevState => ({
          ...prevState,
          modal: { show: false, data: { ...MODAL_INIT_INFO } },
        }))
      },

      onModalSave(newPosicao) {
        setState(prevState => {
          const index = prevState.posicoes.findIndex(p => p.id === newPosicao.id)
          if (index !== -1) {
            prevState.posicoes[index] = newPosicao
          } else {
            prevState.posicoes = [].concat([newPosicao], prevState.posicoes)
          }

          prevState.modal = { show: false, data: { ...MODAL_INIT_INFO } }
          prevState.loadingMessage = LOAD_MESSAGE.GET_POSICOES
          return { ...prevState }
        })
      },

      onSelecionarTodosChange() {
        setState(prev => {
          prev.selecionarTodos = !prev.selecionarTodos
          prev.posicoes.forEach(a => (a.selected = prev.selecionarTodos))
          return { ...prev }
        })
      },

      onItemCheckboxClick(item) {
        const { id } = item
        setState(prev => {
          const index = prev.posicoes.findIndex(a => a.id === id)
          if (index !== -1) {
            prev.posicoes[index].selected = prev.posicoes[index].selected !== true
          }
          return { ...prev }
        })
      },

      onBtnGerarTagAreaClick(selectedTp, posicoes) {
        const posicoesSelecionadas = posicoes.filter(a => a.selected)
        if (posicoesSelecionadas.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Não existe posição selecionada' }))
        } else {
          const param = posicoesSelecionadas.map(p => p.id).toString()
          const url = EstoqueHttp.getUrlTagPosicoes(selectedTp, param)
          openReportInNewTab(url)
        }
      },

      onBtnGerarTagAreaHorizontalClick(selectedTp, posicoes) {
        const posicoesSelecionadas = posicoes.filter(a => a.selected)
        if (posicoesSelecionadas.length === 0) {
          setState(prev => ({ ...prev, errorMessage: 'Não existe posição selecionada' }))
        } else {
          const param = posicoesSelecionadas.map(p => p.id).toString()
          const url = EstoqueHttp.getUrlTagPosicoesHorizontal(selectedTp, param)
          openReportInNewTab(url)
        }
      },

      onChangePosicao(posicao, value) {
        setState(prevState => {
          const index = prevState.posicoes.findIndex(p => p.id === posicao.id)
          if (index !== -1) {
            prevState.posicoes[index].sequencia = value
          }
          return prevState
        })
      },

      onClickSalvarSequencias(posicoes, originalPosicoes) {
        setState(prevState => {
          const posicoesToUpdate = []

          for (const posicao of posicoes) {
            if (typeof posicao.sequencia === 'string' && !posicao.sequencia.length) {
              prevState.errorMessage = `A posicao ${posicao.endereco} está com o campo sequencia vazio.`
              return { ...prevState }
            }
            const posicaoOriginal = originalPosicoes.find(p => p.id === posicao.id)
            if (posicaoOriginal.sequencia !== posicao.sequencia) posicoesToUpdate.push(posicao)
          }

          const totalNumerosSequencia = Array.from(new Set(posicoes.map(p => Number(p.sequencia))))

          if (totalNumerosSequencia.length !== posicoes.length) {
            prevState.errorMessage =
              'Existe posição com o mesmo identificador de sequencia. Operação cancelada.'
            return { ...prevState }
          }

          if (!posicoesToUpdate.length) {
            prevState.errorMessage =
              'Nenhuma posição teve sua sequencia alterada. Operação cancelada.'
            return { ...prevState }
          }

          prevState.posicoesToUpdate = posicoesToUpdate
          prevState.loadingMessage = LOAD_MESSAGE.UPDATE
          return { ...prevState }
        })
      },

      async onClickDeletarPosicoes() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.DELETE_MULTIPLES }))
      },

      async onBtnExportarExcel() {
        const colunasPosicoes = [['endereço', 'sequencia', 'capacidade']]
        gerarArquivoExcel('Posições', colunasPosicoes, `PosicoesDeEstoque.xlsx`)
      },

      async onBtnExportarClick(posicoes) {
        if (posicoes && posicoes.length > 0) {
          const colunas = [
            [
              'Código',
              'Endereço',
              'Sequência',
              'Capacidade'
            ]
          ]

          posicoes.forEach(p => {
              colunas.push([
                p.id,
                p.endereco,
                p.sequencia,
                p.capacidade
              ])
          })

          // A coluna Código é bloqueada para edição, pois é a chave usada na
          // importação das edições de posições.
          const COLUNA_CODIGO = 1
          await gerarArquivoExcelComColunasBloqueadas(
            'Posições do Estoque',
            colunas,
            'posicoes_estoque.xlsx',
            [COLUNA_CODIGO],
          )
        } else {
            setState(prevState => ({
            ...prevState,
            errorMessage: 'Não existe posição para ser exportada.',
          }))
        }
      },

      async onBtnImportarClick(content, selectedEstoque, selectedTp) {
        const headers = content.shift().slice(0, 3)
        const HEADER_SEQUENCE = ['endereço', 'sequencia', 'capacidade']

        const sequencias = content.map(row => row[1])
        const sequenciasUnique = Array.from(new Set(sequencias))
        const capacidades = content.map(row => row[2])

        if (sequencias.some(t => !/^\d+$/.test(t)))
          setState(prevState => ({
            ...prevState,
            errorMessage: 'A coluna sequencia só deve ser preenchida com numeros',
          }))
        else if (sequenciasUnique.length !== sequencias.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Existem números repetidos na coluna de sequencia',
          }))
        else if (capacidades.some(capacidade => !isValidCapacity(capacidade)))
          setState(prevState => ({
            ...prevState,
            errorMessage:
              'A coluna capacidade só deve ser preenchida com números e ter no máximo 6 dígitos',
          }))
        else if (!_.isEqual(headers, HEADER_SEQUENCE))
          setState(prevState => ({
            ...prevState,
            errorMessage: 'A tabela não esta no formato correto',
          }))
        else {
          const posicoes = content.map(c => ({
            estoque_id: selectedEstoque.id,
            endereco: c[0],
            sequencia: c[1],
            capacidade: c[2],
          }))

          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CREATE_POSICOES }))

          await EstoqueHttp.savePosicoesEstoque(selectedTp, posicoes)
            .then(res =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                posicoes: res,
                originalPosicoes: res,
                successMessage: LOAD_MESSAGE.CREATE_POSICOES_SUCCESS_EXCEL,
                selecionarTodos: false,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                loadingMessage: LOAD_MESSAGE.NONE,
                errorMessage: errorHandler(err),
              })),
            )
        }
      },

      async onBtnImportarEdicoesClick(content, selectedEstoque, selectedTp) {
        const setErro = errorMessage =>
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.NONE, errorMessage }))

        const linhas = (content || []).filter(row => !isLinhaVazia(row))

        if (linhas.length < 2)
          return setErro('A planilha importada não possui posições para editar.')

        const headers = linhas.shift().slice(0, 4).map(normalizarTextoHeader)
        if (!_.isEqual(headers, HEADER_EDICAO_POSICOES))
          return setErro(
            'A tabela não esta no formato correto. Utilize o arquivo gerado em "01. Exportar".',
          )

        const posicoes = []

        for (let index = 0; index < linhas.length; index++) {
          const [codigo, endereco, sequencia, capacidade] = linhas[index]
          const numeroLinha = index + 2

          if (!isNumeroInteiroPositivo(codigo))
            return setErro(`A linha ${numeroLinha} está com a coluna código inválida.`)

          if (String(endereco === null || endereco === undefined ? '' : endereco).trim() === '')
            return setErro(`A linha ${numeroLinha} está com a coluna endereço vazia.`)

          if (!isNumeroInteiroPositivo(sequencia))
            return setErro(
              `A linha ${numeroLinha} está com a coluna sequência inválida. Informe um número inteiro maior que zero.`,
            )

          if (!isValidCapacity(capacidade))
            return setErro(
              `A linha ${numeroLinha} está com a coluna capacidade inválida. Informe um número inteiro maior que zero e com no máximo 6 dígitos.`,
            )

          posicoes.push({
            id: Number(codigo),
            endereco: String(endereco).trim(),
            sequencia: Number(sequencia),
            capacidade: Number(capacidade),
          })
        }

        const codigos = posicoes.map(p => p.id)
        if (Array.from(new Set(codigos)).length !== codigos.length)
          return setErro('Existem códigos repetidos na planilha importada. Operação cancelada.')

        // Duplicidade dentro da própria planilha é barrada aqui para dar retorno imediato. O
        // backend refaz a validação sobre o estoque inteiro, incluindo as posições que ficaram
        // de fora da planilha.
        const enderecos = posicoes.map(p => p.endereco.toLowerCase())
        if (Array.from(new Set(enderecos)).length !== enderecos.length)
          return setErro('Existem endereços repetidos na planilha importada. Operação cancelada.')

        const sequencias = posicoes.map(p => p.sequencia)
        if (Array.from(new Set(sequencias)).length !== sequencias.length)
          return setErro('Existem sequências repetidas na planilha importada. Operação cancelada.')

        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.UPDATE_POSICOES_EXCEL,
        }))

        await EstoqueHttp.updatePosicoesEstoqueFromExcel(selectedTp, selectedEstoque.id, posicoes)
          .then(() =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.GET_POSICOES,
              successMessage: LOAD_MESSAGE.UPDATE_POSICOES_SUCCESS_EXCEL,
              selecionarTodos: false,
            })),
          )
          .catch(err => setErro(errorHandler(err)))
      },

      onMenuItemApagarClicked(posicao) {
        setState(prevState => ({
          ...prevState,
          selectedPosicao: posicao,
          loadingMessage: LOAD_MESSAGE.DELETE,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteClose() {
        setState(prevState => ({
          ...prevState,
          modalConfirmDelete: { show: false, data: null },
        }))
      },

      onModalDeleteSave(posicao) {
        this.onMenuItemApagarClicked(posicao)
      },

      verifyMenuItemAllowed(menuItem) {
        return menuItemsAllowed([menuItem]).length > 0
      },
    }
  }, [])

  return { state, localDispatch }
}
